import {
  computed,
  inject,
  provide as _provide,
  unref,
  type InjectionKey,
  type MaybeRef,
  ref
} from 'vue'

export interface AppStateProvider {
  isLoading?: MaybeRef<boolean>
}

export const appStateProviderKey = Symbol(
  'app-state'
) as InjectionKey<AppStateProvider>

export function provideAppState(values: AppStateProvider) {
  _provide(appStateProviderKey, values)
}

export function useAppStateProvider(
  props?: { loading: boolean },
  provide = false
) {
  const injectedValues = inject(appStateProviderKey, {
    isLoading: props?.loading ?? false
  })

  const internalValue = ref(false)

  const isLoading = computed(() => {
    if (internalValue.value) {
      return internalValue.value
    }
    if (typeof props?.loading === 'boolean' && props.loading) {
      return true
    }
    if (injectedValues && injectedValues.isLoading) {
      return unref(injectedValues.isLoading)
    }
    return false
  })

  if (provide) {
    _provide(appStateProviderKey, { isLoading })
  }

  function setIsLoading(val: boolean) {
    internalValue.value = val
  }

  return {
    isLoading,
    setIsLoading
  }
}
